import { render, staticRenderFns } from "./EnviarCorreo2.vue?vue&type=template&id=35809717&scoped=true&"
import script from "./EnviarCorreo2.vue?vue&type=script&lang=js&"
export * from "./EnviarCorreo2.vue?vue&type=script&lang=js&"
import style0 from "./EnviarCorreo2.vue?vue&type=style&index=0&id=35809717&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35809717",
  null
  
)

export default component.exports